export const MyApi = {
  // BASE_URL: "http://192.168.1.6/blogmpublp/api/",
  BASE_URL: "https://blog.mpublp.ac.in/mpublp_admin/api/",
  SECRET_KEY: "Ram#$%&&5554",

  SITE_SETTING: "site-setting", 
  CMS_PAGE: "pages/",  
  BLOGALLLIST : "blog-list",  
  BLOG_DETAILS: "Blogdetails", 
  
};
